import { AuthBaseClient } from '../base-client';
import type {
  ScheduleBlockResponse,
  CreateScheduleBlockRequest,
  CreateScheduleBlockResponse,
  UpdateScheduleBlockRequest,
  CheckOverlapsRequest,
  CheckOverlapsResponse,
} from './types';

export class ScheduleBlockClient extends AuthBaseClient {
  private basePath = '/api/appointments/schedule-blocks';

  async list(options?: {
    providerId?: string;
    locationId?: string;
    fromDate?: string;
    toDate?: string;
  }): Promise<{ blocks: ScheduleBlockResponse[] }> {
    const params = new URLSearchParams();
    if (options?.providerId) params.set('providerId', options.providerId);
    if (options?.locationId) params.set('locationId', options.locationId);
    if (options?.fromDate) params.set('fromDate', options.fromDate);
    if (options?.toDate) params.set('toDate', options.toDate);

    const qs = params.toString();
    return this.get<{ blocks: ScheduleBlockResponse[] }>(`${this.basePath}${qs ? `?${qs}` : ''}`);
  }

  async getById(id: string): Promise<ScheduleBlockResponse> {
    return this.get<ScheduleBlockResponse>(`${this.basePath}/${id}`);
  }

  async checkOverlaps(data: CheckOverlapsRequest): Promise<CheckOverlapsResponse> {
    return this.post<CheckOverlapsResponse>(`${this.basePath}/check-overlaps`, data);
  }

  async create(data: CreateScheduleBlockRequest): Promise<CreateScheduleBlockResponse> {
    return this.post<CreateScheduleBlockResponse>(this.basePath, data);
  }

  async update(id: string, data: UpdateScheduleBlockRequest): Promise<ScheduleBlockResponse> {
    return this.patch<ScheduleBlockResponse>(`${this.basePath}/${id}`, data);
  }

  async remove(id: string): Promise<null> {
    return this.delete<null>(`${this.basePath}/${id}`);
  }
}
